import type { JSXProps, JSXChild } from 'engine/index';

export function BottomRight(props: JSXProps, children: JSXChild[]) {
	return (
		<div {...props} class="fixed bottom-4 right-4 z-10">
			{children}
		</div>
	);
}
